import styled, {
  css,
} from 'styled-components';
import ContentEditable from 'react-contenteditable';

import {
  Flex,
  SVG,
} from 'web-styled';

export const Container = styled(Flex).attrs({
  align: 'center',
  shrink: '0',
})`
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid rgba(40, 45, 48, 0.2);
  background: #ffffff;
`;

export const Sort = styled(Flex).attrs({
  flex: '0 0 20px',
  align: 'center',
  justify: 'flex-start',
})`
  color: ${props => props.theme.colors.primary};
  width: 20px;
  height: 20px;
  opacity: 0.8;
  cursor: move;
  text-align: center;

  &:hover {
    opacity: 1;
  }

  @media print {
    display: none;
  }
`;

export const Search = styled(Flex).attrs({
  align: 'center',
})`
  position: absolute;
  top: 38px;
  left: 0px;
  z-index: 99;
  width: 100%;
  background: #fff;

  & > div {
    width: 100%;
  }
`;

const weekName = css`
  color: #797979;
  font-size: 14px;
  font-weight: bold;
  border: none;
  outline: none;
  white-space: nowrap;
  overflow: hidden;
  margin-right: 12px;
`;

export const WeekName = styled.div`
  ${weekName}
`;

export const EditableWeekName = styled(ContentEditable)`
  ${weekName}
`;

export const ActionsTrigger = styled(Flex).attrs({
  align: 'center',
  justify: 'center',
})`
  position: relative;
  width: 20px;
  height: 30px;
  cursor: pointer;
  flex-shrink: 0;
  margin-left: auto;

  svg {
    position: absolute;
    cursor: pointer;
  }
`;

export const ContextMenu = styled(SVG.ContextMenu).attrs(
  props => ({
    width: 20,
    height: 30,
    stroke: props.theme.colors.primary,
    transform: 'scale(1.6)',
  }),
)``;
